/* ==========================================================
   INYECTAR CSS GLOBAL PARA MATAR LA VARIANTE "DEFAULT"
   (Horizon usa pills muy agresivos → CSS gana siempre)
   ========================================================== */
(function () {
  const style = document.createElement('style');
  style.textContent = `
    /* Desactivar clic */
    label.variant-option__button-label input[value*="Default"],
    label.variant-option__button-label input[value*="default"] {
      pointer-events: none;
    }

    /* Ocultar entero el pill si contiene la variante Default */
    label.variant-option__button-label:has(input[value*="Default"]),
    label.variant-option__button-label:has(input[value*="default"]) {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
})();


/* ==========================================================
   UTILIDAD → Obtener primera variante REAL (no Default)
   ========================================================== */
function getFirstRealVariant(product) {
  if (!product || !product.variants) return null;

  return product.variants.find(v => {

    // Seguridad total
    const title = (v.title || "").toString().toLowerCase();

    return !title.includes("default");

  }) || product.variants[0] || null;
}


/* ==========================================================
   MAIN SCRIPT
   ========================================================== */
document.addEventListener("DOMContentLoaded", () => {

  /* --------------------------------------------------------
     1. OCULTAR PILLS DE VARIANTES (por si aparece antes del CSS)
     -------------------------------------------------------- */
  document.querySelectorAll('label.variant-option__button-label').forEach(label => {
    const input = label.querySelector('input[type="radio"]');
    if (!input) return;
    if (input.value.trim().toLowerCase().includes("default")) {
      label.style.display = "none";
    }
  });


  /* --------------------------------------------------------
     2. OCULTAR OPTIONS EN SELECTS
     -------------------------------------------------------- */
  document.querySelectorAll("select[name='id']").forEach(select => {
    [...select.options].forEach(opt => {
      if (opt.textContent.trim().toLowerCase().includes("default")) {
        opt.hidden = true;
        opt.disabled = true;
      }
    });
  });


  /* --------------------------------------------------------
     3. OCULTAR TEXTO SUELTO "Default"
     -------------------------------------------------------- */
  document.querySelectorAll("*").forEach(el => {
    if (
      el.childNodes.length === 1 &&
      el.textContent.trim().toLowerCase() === "default"
    ) {
      el.style.display = "none";
    }
  });


  /* --------------------------------------------------------
     4. OCULTAR DEFAULT EN FILTROS DE COLECCIÓN
     -------------------------------------------------------- */
  document.querySelectorAll(".facets__inputs-list-item").forEach(li => {
    const input = li.querySelector("input");
    if (!input) return;
    if (input.value.trim().toLowerCase().includes("default")) {
      li.style.display = "none";
    }
  });


  /* --------------------------------------------------------
     5. PRODUCT JSON → FORZAR VARIANTE REAL
     -------------------------------------------------------- */
  const pd = window?.meta?.product || window?.__st?.page_data;

  if (pd && pd.variants) {
    const realVariant = getFirstRealVariant(pd);

    if (realVariant) {

      pd.selected_variant = realVariant;
      pd.variants[0] = realVariant;

      /* ACTUALIZAR PRECIO */
      const priceEls = document.querySelectorAll(
        '[data-product-price], .price--highlight, .product__price'
      );
      priceEls.forEach(el => {
        el.innerHTML = Shopify.formatMoney(realVariant.price, Shopify.money_format);
      });

      /* ACTUALIZAR COMPARE PRICE */
      const compareEls = document.querySelectorAll(
        '[data-compare-price], .price--compare, .product__compare'
      );
      compareEls.forEach(el => {
        if (realVariant.compare_at_price > realVariant.price) {
          el.innerHTML = Shopify.formatMoney(realVariant.compare_at_price, Shopify.money_format);
          el.style.display = "inline";
        } else {
          el.style.display = "none";
        }
      });
    }
  }


  /* --------------------------------------------------------
     6. TARJETAS DE COLECCIÓN → PRECIOS CORRECTOS
     -------------------------------------------------------- */
  document.querySelectorAll('.card-wrapper[data-product-handle]').forEach(card => {

    const jsonEl = card.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    const data = JSON.parse(jsonEl.textContent);
    const realVariant = getFirstRealVariant(data);
    if (!realVariant) return;

    const priceEl = card.querySelector('.price-item--regular');
    if (priceEl) {
      priceEl.innerHTML = Shopify.formatMoney(realVariant.price, Shopify.money_format);
    }

    const compareEl = card.querySelector('.price-item--sale');
    if (compareEl) {
      if (realVariant.compare_at_price > realVariant.price) {
        compareEl.innerHTML = Shopify.formatMoney(realVariant.compare_at_price, Shopify.money_format);
      } else {
        compareEl.style.display = 'none';
      }
    }

    const badge = card.querySelector('.badge--sale');
    if (badge && !(realVariant.compare_at_price > realVariant.price)) {
      badge.style.display = 'none';
    }
  });


  /* --------------------------------------------------------
     7. OBSERVER PARA QUICKVIEW / AJAX RERENDER
     -------------------------------------------------------- */
  const observer = new MutationObserver(() => {

    // Ocultar pill Default si reaparece
    document.querySelectorAll('label.variant-option__button-label').forEach(label => {
      const input = label.querySelector("input[type='radio']");
      if (input && input.value.trim().toLowerCase().includes("default")) {
        label.style.display = "none";
      }
    });

    // Ocultar Default en filtros
    document.querySelectorAll(".facets__inputs-list-item").forEach(li => {
      const input = li.querySelector("input");
      if (input && input.value.trim().toLowerCase().includes("default")) {
        li.style.display = "none";
      }
    });

  });

  observer.observe(document.body, { childList: true, subtree: true });

});
